module.exports = __webpack_public_path__ + "img/nojunkm.29d180a3.jpg";